export default "__VITE_ASSET__CHaVTFP6__"